import React, { Component } from 'react';
import styles from './style.module.scss';
import { RouteComponentProps } from 'react-router';

export default class HelpMePage extends Component<RouteComponentProps<{}>> {
	render() {
		return (
			<div className={styles.container}>
				<article>Can we help you?</article>
				<img src={require('./help.png')} />
				<div>
					If you have any questions or need assistance, please email our head of customer
					success <a href="mailto:anna@yomento.com">anna@yomento.com</a>
				</div>
			</div>
		);
	}
}
